import { I18n } from "@/i18n/I18n";
import { Link, useNavigate } from "react-router-dom";
import { useRequirementsStore } from "@/frontend/store/RequirementsStore";
import { CreateRequirementModal } from "./CreateRequirementModal";
import { RequirementParams, RequirementSubjectType } from "@/backend/access/requirement/types";
import { List } from "@/frontend/SVGs/List";
import { ButtonParent } from "../buttons/ButtonParent";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { FusawarePermission } from "@/frontend/fusawareUser";
import { requirementPath } from "@/frontend/utils/requirementPath";

interface OrganizationRequirementsProps {
  fusaOrganizationId: string;
}

export function OrganizationRequirements({ fusaOrganizationId }: OrganizationRequirementsProps) {
  const { organizationRequirements } = useRequirementsStore();
  const userClass = useGlobalStore(state => state.userClass);

  return (
    <div>
      {userClass?.fusaHasPermission(FusawarePermission.EDIT_HIERARCHY) && (
        <div className="d-flex mb-3">
          <CreateRequirementModal 
            subjectId={fusaOrganizationId} 
            subjectType={RequirementSubjectType.FUSA_ORGANIZATION} 
          />
        </div>
      )}
      {organizationRequirements.length === 0 ? (
        <p className="text-muted">{I18n.get('noRequirementsFound')}</p>
      ) : (
        <OrganizationRequirementsTable tableItems={organizationRequirements} />
      )}
    </div>
  );
}

function OrganizationRequirementsTable({ tableItems }: { tableItems: RequirementParams[] }) {

  const navigate = useNavigate();

  return (
    <table className="table table-hover">
      <thead className="sticky-top">
        <tr>
          <th>{I18n.get('title')}</th>
          <th>{I18n.get('actions')}</th>
        </tr>
      </thead>
      <tbody>
        {tableItems.map((requirement) => (
          <tr key={requirement.id}>
            <td>
              <Link 
                to={requirementPath(requirement)} 
                className="link-body-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover"
              >
                {requirement.name}
              </Link>
            </td>
            <td>
              <ButtonParent 
                onClick={() => void navigate(requirementPath(requirement))} 
                title={I18n.get('viewRequirement')} 
                className="btn btn-sm btn-secondary d-inline-flex align-items-center"
              >
                <List />
              </ButtonParent>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
